import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const TrainingReport = () => {

const [topics,setTopics] = useState([]);
const [reports,setReports] = useState([]);

const today = new Date().toISOString().split("T")[0];

const [formData,setFormData] = useState({
    start_date:today,
    end_date:today,
    topic_id:"",
    action_type:"fetch"
});

useEffect(()=>{
    fetchTopics();
},[]);

const fetchTopics = async ()=>{
    try{
        const res = await axios.get(API_BASE_URL + "/training-topics", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
       
        console.log(res.data);
        setTopics(res.data);
    }catch(err){
        console.error(err);
    }
};

const handleChange = (e)=>{
    setFormData({
        ...formData,
        [e.target.name]:e.target.value
    });
};

const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    // Excel Download
    if (formData.action_type === "list_download") {

      const res = await axios.post(
        `${API_BASE_URL}/training-listreportdownload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          },
          responseType: "blob"
        }
      );

      const file = new Blob([res.data], {
        type: "application/vnd.ms-excel"
      });

      const url = window.URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "training_report.xls");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return;
    }

    // 🔴 Feedback PDF Download
    if (formData.action_type === "feedback_download") {

      const res = await axios.post(
        `${API_BASE_URL}/training-feedback-download`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          },
          responseType: "blob"
        }
      );

      const file = new Blob([res.data], {
        type: "application/pdf"
      });

      const url = window.URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "training_feedback.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return;
    }

    // Normal Fetch
    if (formData.action_type === "fetch") {

      const res = await axios.post(
        `${API_BASE_URL}/training-report`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setReports(res.data.data);
    }

  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

const renderStatus = (value)=>{
    return value === 1
        ? <span style={{color:"green",fontWeight:"bold"}}>Completed</span>
        : <span style={{color:"red",fontWeight:"bold"}}>Not Completed</span>
};




const openFeedbackPdf = async (id) => {
    window.open(API_BASE_URL +'/training-reportdownload/'+id, '_blank')
     };

return (

<div className="container-fluid">

{/* Card 1 */}
<div className="card mb-4">

<div className="card-header">
Training Details Download
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="row">

<div className="col-md-2">
<label>From Date</label>
<input
type="date"
className="form-control"
name="start_date"
value={formData.start_date}
onChange={handleChange}
/>
</div>

<div className="col-md-2">
<label>To Date</label>
<input
type="date"
className="form-control"
name="end_date"
value={formData.end_date}
onChange={handleChange}
/>
</div>

<div className="col-md-4">
<label>Training Topic</label>
<select
className="form-control"
name="topic_id"
value={formData.topic_id}
onChange={handleChange}
>

<option value="">Select Topic</option>

{topics.map((topic)=>(
<option key={topic.id} value={topic.id}>
{topic.topic_name}
</option>
))}

</select>
</div>

<div className="col-md-2">
<label>Action</label>
<select
className="form-control"
name="action_type"
value={formData.action_type}
onChange={handleChange}
>

<option value="fetch">Fetch</option>
<option value="list_download">List Download</option>
<option value="feedback_download">Feedback Download</option>

</select>
</div>

<div className="col-md-2" style={{marginTop:"30px"}}>
<button className="btn btn-primary">
Get
</button>
</div>

</div>

</form>

</div>

</div>


{/* Card 2 */}

<div className="card">

<div className="card-header">
List All Training Report
</div>

<div className="table-responsive">

<table className="table table-striped table-bordered">

<thead>

<tr>
<th>Action</th>
<th>Course</th>
<th>Topic</th>
<th>Employee Details</th>
<th>Training Date</th>
<th>Pre-Test Status</th>
<th>Pre-Test Percentage</th>
<th>Training Status</th>
<th>Post Test Status</th>
<th>Post Test Percentage</th>
<th>Feedback Status</th>
</tr>

</thead>

<tbody>

{reports.map((row,index)=>(

<tr key={index}>

<td>
<button
className="btn btn-sm btn-danger"
onClick={() => openFeedbackPdf(row.id)}
>
<i className="fa fa-file-pdf"></i>
</button>
</td>

<td>{row.course_name}</td>
<td>{row.topic_name}</td>
<td>{row.employee_name}</td>
<td>{row.training_date}</td>

<td>{renderStatus(row.pre_test_status)}</td>
<td>{row.pre_test_percentage}%</td>

<td>{renderStatus(row.training_view_status)}</td>

<td>{renderStatus(row.post_test_status)}</td>
<td>{row.post_test_percentage}%</td>

<td>{renderStatus(row.training_feedbacks)}</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

</div>

);
};

export default TrainingReport;